import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export default function SelectItem(props) {
    function getMenuItems(array) {
        return array.map((element, index) => <MenuItem key={index} value={element['value']}>{element['data']}</MenuItem>);
    }

    return(
        <Select
            label={props.label}
            name={props.name}
            value={props.info[props.name] || "default"}
            sx={{ width: '100%' }}
            onChange={props.onChange}
        >
            <MenuItem value={"default"} disabled>{props.default}</MenuItem>
            {props.array && getMenuItems(props.array)}
        </Select>
    )
}